import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import type {
  IconColor,
  IconName,
} from '@mylighthouse/prism-ember/types/components/prism/icon';

export interface StepperPanelStep {
  description?: string;
  icon: IconName;
  isActive?: boolean;
  isComplete?: boolean;
  isPartOfFlow?: boolean;
  isSelected?: boolean;
  title: string;
}

interface HotelBenchmarkInsightCompetitorsCompsetBuilderStepperPanelStepSignature {
  Args: {
    step: StepperPanelStep;
  };
}

export default class HotelBenchmarkInsightCompetitorsCompsetBuilderStepperPanelStep extends Component<HotelBenchmarkInsightCompetitorsCompsetBuilderStepperPanelStepSignature> {
  get iconColor(): IconColor {
    const { isComplete, isActive, isSelected } = this.args.step;

    if (isComplete || isSelected) {
      return 'default-inverse';
    }

    if (isActive) {
      return 'disabled';
    }

    return 'default';
  }

  <template>
    <div class="stepper-panel-step flex flex-row items-start gap-300">
      <div
        class="stepper-panel-step__icon
          {{if @step.isPartOfFlow 'stepper-panel-step__icon--with-line'}}"
      >
        <div
          class="stepper-panel-step__icon__content
            {{if
              @step.isComplete
              'stepper-panel-step__icon__content--complete'
            }}
            {{if
              @step.isSelected
              'stepper-panel-step__icon__content--selected'
            }}
            flex items-center justify-center"
        >
          <PrismIcon @color={{this.iconColor}} @name={{@step.icon}} />
        </div>
      </div>

      <div class="flex flex-col justify-center gap-100">
        <p
          class="text-300--medium
            {{unless @step.description 'text-neutral-subdued'}}"
        >{{@step.title}}</p>
        {{#if @step.description}}
          <p
            class="text-200--regular text-neutral-subdued"
          >{{@step.description}}</p>
        {{/if}}
      </div>
    </div>
  </template>
}
